import { render, staticRenderFns } from "./UsuarioEditPassword.vue?vue&type=template&id=94b869a4&"
import script from "./UsuarioEditPassword.vue?vue&type=script&lang=js&"
export * from "./UsuarioEditPassword.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioEditPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports